export const BestandViewHeaders=[
    {
        id:1,
        title:'Firma Kurz',
        width: '27%'
    },
    {
        id:2,
        title:'Zust. FKB',
        width: '11%'
    },
    {
        id:3,
        title:'Bank',
        width: '11%'
    },
    {
        id:4,
        title:'Region',
        width: '11%'
    },
    {
        id:5,
        title:'Kd-Berater Bank',
        width: '11%'
    },
    {
        id:6,
        title:'MA',
        width: '3%'
    },
    {
        id:7,
        title:'P-Status',
        width: '11%'
    },
    {
        id:8,
        title:'P-Datum',
        width: '11%'
    },
    {
        id:9,
        title:'WV',
        width: '11%'
    },
    {
        id:17,
        title: 'Bemerk',
        mouseOver: 'Bemerkung',
        width: '3%'
    },
]

export const BestandViewHeadersDGG=[
    {
        id:1,
        title:'Firma Kurz',
        width: '20%'
    },
    {
        id:2,
        title:'Firma',
        width: '26%'
    },
    {
        id:6,
        title:'MA',
        width: '3%'
    },
    {
        id:18,
        title:'Vertrieb',
        width: '3%'
    },
    {
        id:3,
        title:'Zust. VP',
        width: '11%'
    },
    {
        id:4,
        title:'Zust. ADM',
        width: '11%'
    },
    {
        id:5,
        title:'P-Status',
        width: '11%'
    },
    {
        id:8,
        title:'P-Datum',
        width: '11%'
    },
    {
        id:9,
        title:'WV',
        width: '11%'
    },
    {
        id:17,
        title: 'Bemerk',
        mouseOver: 'Bemerkung',
        width: '3%'
    },
]
